import { useTheme } from '../../hooks/useTheme';

import { NAV_THEMES } from './nav-tokens';
import type { AppModeInfo } from './use-app-mode';

interface AccountHeaderProps {
  viewer: AppModeInfo;
}

/** Who you are signed in as, as one muted line: name, then the mode and region
 *  scope `scopeLabel` already formats. The email is left out — it identifies
 *  nobody the name does not, and the row has to sit in a 264px panel. */
export default function AccountHeader({ viewer }: AccountHeaderProps) {
  const { theme } = useTheme();
  const t = NAV_THEMES[theme];
  return (
    <div className="px-4 pb-1.5 pt-1 text-[13px]" style={{ color: t.muted }}>
      {viewer.displayName} · {viewer.scopeLabel}
    </div>
  );
}
